import { useEffect, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import { GeneralContext } from '../../../core/app-context/GeneralContext';
import { RoutesMapping } from '../../../core/route/routesMapping';
import Services from '../services';
import useConfigsStore from '../store/configsStore';

export default function useGetConfigs() {
  const redirect = useNavigate();
  const { storeNameId } = useParams();
  const { setErrorMessage } = useContext(GeneralContext);
  const setConfigs = useConfigsStore((state) => state.setPageConfigs);
  const setStoreId = useConfigsStore((state) => state.setStoreId);
  const setLoadingConfigs = useConfigsStore((state) => state.setLoadingConfigs);

  useEffect(() => {
    const fetchConfigs = async () => {
      if (storeNameId) {
        const storeId = await Services.getStoreIdByNameId(storeNameId);
        if (!storeId) {
          // Forces redirect to 404 page, because it's not actually a not found route,
          // but it's the route param that was not found. As we consider the param route a new route
          // for each client, we must redirect to the not found page.
          return redirect(RoutesMapping.NOT_FOUND_ROUTE, { replace: true });
        }
        setStoreId(storeId);
        const configs = await Services.getDevolutionPageData(storeId);
        if (!configs) {
          return redirect(RoutesMapping.INTERNAL_SERVER_ERROR, {
            replace: true,
          });
        }
        setConfigs(configs);
        setLoadingConfigs(false);
      }
    };
    fetchConfigs();
  }, [storeNameId]);
}
